<div class="min-vh-100 d-xl-flex">

  <!-- Sidebar + Backdrop -->
  <div>
    <app-sidebar></app-sidebar>

    <div
      class="backdrop d-xl-none"
      *ngIf="layoutService.isMobileOpen$ | async"
      (click)="layoutService.setMobileOpen(false)"
    ></div>
  </div>

  <!-- Main Content Wrapper -->
  <div
    class="flex-fill content-wrapper d-flex flex-column"
    [ngClass]="{
      'content-expanded': (layoutService.isExpanded$ | async) || (layoutService.isHovered$ | async),
      'content-collapsed': !(layoutService.isExpanded$ | async) && !(layoutService.isHovered$ | async),
      'content-mobile': (layoutService.isMobileOpen$ | async)
    }"
  >
    <!-- ✅ Fixed Header -->
    <header class="app-header">
      <app-header></app-header>
    </header>

    <!-- ✅ Scrollable Content -->
    <main class="container-fluid content-main flex-fill">
      <router-outlet></router-outlet>
    </main>

    <!-- ✅ Fixed Footer -->
    <footer class="app-footer">
      <app-footer></app-footer>
    </footer>
  </div>

</div>
